import React, { useCallback } from 'react';

import { ReportingContext } from '@sopranodesign/pulse-errors';

import { logError, setContext, setTag, setUser, clearScope } from '../config/datadog';

const ReportingProvider = ({ children }) => {
  const report = useCallback((error, info) => {
    logError(error, info);
  }, []);

  const context = {
    report,
    setContext,
    setTag,
    setUser,
    clearScope
  };

  return (
    <ReportingContext.Provider value={context}>
      {children}
    </ReportingContext.Provider>
  );
};

export default ReportingProvider;
